export default "{\n    \"pageTitle\": \"Nueva orden de trabajo\",\n    \"heading\": \"Crear orden de trabajo\",\n    \"submitButtonLabel\": \"Enviar\"\n}\n"